import { Translation } from '@shared/types/translation';

export const SUPPORT_MODAL_LABELS = {
  COPIED: {
    english: 'Copied',
    polish: 'Skopiowano',
  },
} as const satisfies Record<string, Translation>;

export const USER_PROFILE_DROPDOWN_LABELS = {
  SETTINGS: {
    english: 'Settings',
    polish: 'Ustawienia',
  },
} as const satisfies Record<string, Translation>;
